import styled from 'styled-components';

import {colors, font} from 'theme';

export const H1 = styled.h1`
    color: ${colors.textPrimary};
    margin-bottom: 16px;
    font-family: ${font.family.primary};

    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 120% */
    text-transform: uppercase;
    margin: 0;
`;

export const H2 = styled.h2`
    color: ${colors.textPrimary};
    margin-bottom: 16px;
    font-family: ${font.family.primary};
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-transform: uppercase;
`;

export const MarkingCodeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    box-sizing: border-box;
    border-radius: 8px;
    border: 0.688px solid #e2e2e2;
    background: #fff;
    padding: 16px;
    gap: 10px;
`;

export const ProductGroupIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 53px;
    height: 100%;
`;

export const MarkingCodeInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const MarkingCodeInfoText = styled.span`
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 21px;
    word-break: break-word;
`;

export const MarkingCodeInfoSubtext = styled.div`
    display: flex;
    gap: 8px;
    color: ${colors.textMuted};
    font-family: ${font.family.primary};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
`;

export const SubmitButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
`;
